import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem("vds_cookie_accepted");
        if (!accepted) setShow(true);
    }, []);

    if (!show) return null;

    const accept = () => {
        localStorage.setItem("vds_cookie_accepted", "1");
        setShow(false);
    };

    return (
        <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-50 bg-zinc-950 text-white px-6 py-4 border-t border-zinc-800">
            <div className="max-w-[1400px] mx-auto flex flex-wrap items-center justify-between gap-4">
                <p className="text-sm flex-1 min-w-[260px]">
                    🍪 We gebruiken alleen functionele cookies voor login en winkelmandje. Geen tracking, geen marketing.
                    <Link to="/privacy" className="ml-2 underline">Meer info</Link>
                </p>
                <button data-testid="cookie-accept" onClick={accept} className="bg-white text-zinc-950 px-5 py-2 text-xs font-bold uppercase tracking-widest hover:bg-zinc-100 transition">
                    OK begrepen
                </button>
            </div>
        </div>
    );
}
